import Swiper, { Navigation, A11y } from 'swiper';
Swiper.use([Navigation, A11y]);

export const SMALL_CAROUSEL_BREAKPOINTS = {
    0: {
        slidesPerView: 1.2,
        spaceBetween: 16,
        centeredSlides: false,
        slidesOffsetAfter: 16,
    },
    568: {
        slidesPerView: 1.6,
        spaceBetween: 16,
        centeredSlides: false,
        slidesOffsetAfter: 16,
    },
    768: {
        slidesPerView: 1.6,
        spaceBetween: 24,
        centeredSlides: false,
        slidesOffsetAfter: 0,
    },
};

export const STANDARD_CAROUSEL_BREAKPOINTS = {
    0: {
        slidesPerView: 1.2,
        spaceBetween: 16,
        centeredSlides: false,
        slidesOffsetBefore: 16,
        slidesOffsetAfter: 16,
    },
    640: {
        slidesPerView: 1.4,
        spaceBetween: 16,
        centeredSlides: false,
        slidesOffsetBefore: 24,
        slidesOffsetAfter: 24,
    },
    768: {
        slidesPerView: 2.3,
        spaceBetween: 24,
        centeredSlides: false,
        slidesOffsetBefore: 40,
        slidesOffsetAfter: 40,
    },
    1024: {
        slidesPerView: 2.7,
        spaceBetween: 24,
        centeredSlides: false,
        slidesOffsetBefore: 40,
        slidesOffsetAfter: 40,
    },
    1152: {
        slidesPerView: 3.2,
        spaceBetween: 24,
        centeredSlides: false,
        slidesOffsetBefore: 40,
        slidesOffsetAfter: 40,
    },
    1280: {
        slidesPerView: 3.5,
        spaceBetween: 24,
        centeredSlides: false,
        slidesOffsetBefore: 0,
        slidesOffsetAfter: 0,
    },
};

interface MembershipLevelCarouselSectionProps {
    scrollTarget?: number;
}

interface MembershipLevelCarouselProps {
    el: HTMLElement;
    props: MembershipLevelCarouselSectionProps;
}

const MembershipLevelCarousel = ({ el, props }: MembershipLevelCarouselProps): void => {
    const { scrollTarget } = props;
    const carousel: HTMLElement | null = el.querySelector('.membership-level-carousel-swiper');
    // const smallCarousel: boolean | null = el.classList.contains('membership-level-carousel-sm');
    const controlNext: HTMLElement | null = el.querySelector('.carousel-control-next');
    const controlPrev: HTMLElement | null = el.querySelector('.carousel-control-prev');

    const targetCarousel = carousel;

    if (!targetCarousel || !controlNext || !controlPrev) {
        return;
    }

    const mccPanelAncestor = el.closest('.mcc-panel');
    const mccPanelStyleguideAncestor = el.closest('.my-mcc-container');

    const isInMyMCCPanel = !!mccPanelAncestor || !!mccPanelStyleguideAncestor;

    const membershipLevelCarousel = new Swiper(targetCarousel, {
        init: false,
        navigation: {
            nextEl: controlNext,
            prevEl: controlPrev,
        },
        pagination: false,
        breakpoints: isInMyMCCPanel
            ? SMALL_CAROUSEL_BREAKPOINTS
            : STANDARD_CAROUSEL_BREAKPOINTS,
    });

    membershipLevelCarousel.init();

    if (typeof scrollTarget === 'number' && Number.isFinite(scrollTarget)) {
        const slideIndex = Math.max(0, Math.floor(scrollTarget - 1));
        membershipLevelCarousel.slideTo(slideIndex);
    }
};

export default MembershipLevelCarousel;
